import React, { useEffect, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate.js"; // Import your configured axios instance
import "./UsersList.css"; // Import the CSS file
import { formatDate } from "../../utils/Utilities.js";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";


const ListManifestInScanByDate = () => {
  const navigate = useNavigate();
  const handleRedirect = () => {
    navigate("/ManifestInScan");
  }
  const [ListManifestInScanByDate, setListManifestInScanByDate] = useState([]); // To store list of ListManifestInScanByDate
  const [loading, setLoading] = useState(false); // Set loading initially to false
  const [error, setError] = useState(null); // To handle errors
  const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
  const [fromDate, setFromDate] = useState(""); // To store the from_date value
  const [toDate, setToDate] = useState(""); // To store the to_date value
  const ListManifestInScanByDatePerPage = 10; // Number of ListManifestInScanByDate per page
  const axiosPrivate = useAxiosPrivate();
  const LIST_MANIFEST_IN_SCAN_URL = "api/list-manifest-inscan"; // Replace with the correct API endpoint to fetch ListManifestInScanByDate
  const { auth } = useAuth();


  // Fetch ListManifestInScanByDate based on from_date and to_date
  const fetchListManifestInScanByDate = async (fromDate, toDate) => {
    setLoading(true); // Start loading spinner
    try {
      const fromDate_Formated = formatDate(fromDate);
      const toDate_Formated = formatDate(toDate);
      const data = {
        franchise_id: auth.franchise_id,
        from_date: fromDate_Formated,
        to_date: toDate_Formated,
      };

      const response = await axiosPrivate.get(LIST_MANIFEST_IN_SCAN_URL, {
        params: data,
      });

      setListManifestInScanByDate(response.data); // Store the list of ListManifestInScanByDate into the state
      setLoading(false); // Stop loading spinner
      setError(null); // Clear any previous error
    } catch (error) {
      console.error("Error fetching Bookings Consignments:", error);
      setError("Failed to load Booking Consignments");
      setLoading(false); // Set loading to false even if there is an error
    }
  };

  // Handle the search button click to fetch data with the new dates
  const handleSearch = () => {
    if (fromDate && toDate) {
      fetchListManifestInScanByDate(fromDate, toDate);
      setError(null); // Clear the error if dates are valid
    } else {
      setError("Please enter both from and to dates."); // Show error if dates are missing
    }
  };

  // Paginate ListManifestInScanByDate
  const indexOfLastListManifestInScanByDate = currentPage * ListManifestInScanByDatePerPage;
  const indexOfFirstListManifestInScanByDate = indexOfLastListManifestInScanByDate - ListManifestInScanByDatePerPage;
  const currentListManifestInScanByDate = ListManifestInScanByDate.slice(indexOfFirstListManifestInScanByDate, indexOfLastListManifestInScanByDate);

  // Pagination handler
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Total pages needed for pagination
  const totalPages = Math.ceil(ListManifestInScanByDate.length / ListManifestInScanByDatePerPage);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <>


      <section className="newsections">

        <div className="newwrap">

          <div className="d-flex align-items-center">
            {/* Left */}
            <button
              onClick={() => navigate(-1)}
              className="btn btn-secondary newviewbtn"
            >
              ← Back
            </button>

            {/* Right */}
            <div className="ms-auto">
              <button
                onClick={handleRedirect}
                type="button"
                className="btn btn-success top-bt"
              >
                Manifest InScan
              </button>
            </div>
          </div>

          <h3>Manifest InScan List</h3>

          {/* Date Filters and Search Button */}
          <center><div className="search-filters newfilter">
            <label htmlFor="fromDate">From Date:</label>
            <input
              type="date"
              id="fromDate"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
            <label htmlFor="toDate">To Date:</label>
            <input
              type="date"
              id="toDate"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
            <br />
            <button onClick={handleSearch} className="btn scanbutton">Search</button>
          </div>
          </center>

          {/* Show error message if both dates are not provided */}
          {error && (
            <div className="error-message">
              <div className="error">{error}</div>
              {/* Show the search filters again below the error */}
            </div>
          )}

          {/* Show the table for displaying ListManifestInScanByDate only when there are results */}
          {ListManifestInScanByDate.length > 0 && !error && (
            <>
              <table border="1" id="customers">
                <thead>
                  <tr>
                    <th>Manifest number</th>
                    <th>Manifest date</th>
                    <th>Destination franchise</th>
                    <th>Total cons.</th>
                    <th>Weight</th>
                    <th>Scan Time</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {currentListManifestInScanByDate.map((ListManifestInScanByDate) => (
                    <tr key={ListManifestInScanByDate.manifest_number}>
                      <td>{ListManifestInScanByDate.manifest_number}</td>
                      <td>{ListManifestInScanByDate.manifest_date}</td>
                      <td>{ListManifestInScanByDate.manifest_destination_franchise_name} - {ListManifestInScanByDate.manifest_destination_franchise_code}</td>
                      <td>{ListManifestInScanByDate.total_consignments}</td>
                      <td>{ListManifestInScanByDate.weight}</td>
                      <td>{ListManifestInScanByDate.scan_time}</td>
                      <td>{ListManifestInScanByDate.current_status}</td>

                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Pagination - only show if there are multiple pages */}
              {totalPages > 1 && (
                <div className="pagination">
                  {Array.from({ length: totalPages }, (_, index) => (
                    <button
                      key={index}
                      onClick={() => handlePageChange(index + 1)}
                      disabled={currentPage === index + 1}>
                      {index + 1}
                    </button>
                  ))}
                </div>
              )}
            </>
          )}

          {/* If no ListManifestInScanByDate and error isn't shown, display a "No results" message */}
          {ListManifestInScanByDate.length === 0 && !loading && !error && (
            <div className="no-results">
              <p>No Booking Consignments found for the selected date range.</p>
            </div>
          )}
        </div>
      </section>
      <TopBar />
    </>
  );
};

export default ListManifestInScanByDate;
